import React from 'react'
import Header from '../components/header'
import BreadCrumb from '../components/BreadCrumb'
import Footer from '../components/footer'
import FullBlogArea from '../components/FullBlogArea'


function BlogPage() {
  const pageName = "Blog/News"
  return (
    <div className='home-3'>
      <Header/>
      <BreadCrumb pageName={pageName}/>
      <main>
        <FullBlogArea/>
      </main>
      <Footer/>
    </div>
  )
}

export default BlogPage